import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleSize", "titleProps", "description", "alignment", "descriptionProps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { ALIGNMENT } from "../../constants/alignment";
import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_SIZE, SIZES } from "../typography/headline";
import { Wrapper, Title, Description, StyledMarkdown } from "./headline-and-text.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeadlineAndText = function HeadlineAndText(props) {
  var _rest$style;
  var title = props.title,
    titleSize = props.titleSize,
    titleProps = props.titleProps,
    description = props.description,
    alignment = props.alignment,
    descriptionProps = props.descriptionProps,
    rest = _objectWithoutProperties(props, _excluded);
  var textColor = rest === null || rest === void 0 ? void 0 : (_rest$style = rest.style) === null || _rest$style === void 0 ? void 0 : _rest$style.color;
  var titleStyle = {};
  if (textColor) {
    titleStyle.color = textColor;
  }
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
    alignment: alignment
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx(Title, _objectSpread(_objectSpread({
      id: encodeURIComponent(title),
      size: titleSize
    }, titleProps), {}, {
      style: titleStyle,
      children: title
    })), !!description && /*#__PURE__*/_jsx(Description, _objectSpread(_objectSpread({
      as: 'div'
    }, descriptionProps), {}, {
      children: /*#__PURE__*/_jsx(StyledMarkdown, {
        color: textColor,
        children: description
      })
    }))]
  }));
};
HeadlineAndText.displayName = 'HeadlineAndText';
HeadlineAndText.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleSize: PropTypes.oneOf(Object.values(SIZES)),
  alignment: PropTypes.oneOf(Object.values(ALIGNMENT)),
  descriptionProps: PropTypes.object,
  titleProps: PropTypes.object
};
HeadlineAndText.defaultProps = {
  description: null,
  titleSize: DEFAULT_SIZE,
  alignment: ALIGNMENT.DEFAULT,
  descriptionProps: {},
  titleProps: null
};
export default HeadlineAndText;